import { createSlice } from "@reduxjs/toolkit";

const initialState = { state: {} };
export const usersRolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setUserRoles: (state, action) => {
      state.state = action.payload;
    },
  },
});

export const { setUserRoles } = usersRolesSlice.actions;
export default usersRolesSlice.reducer;
